export default "/images/vendor/flag-icon-css/flags/4x3/be.svg?251f80c01a359e2031996ceb53e4190f";